// extracted by mini-css-extract-plugin
module.exports = {"innerCard":"Stopwatch_innerCard__275zr","footer":"Stopwatch_footer__2O88D"};